import React from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import LoadingPage from './pages/LoadingPage';
import HomePage from './pages/HomePage';
import GetWhiteListed from './pages/Get-Whitelisted'



function App() {
  return (
    <Router>
      <Route exact path="/" component={LoadingPage} />
      <Route path="/home" component={HomePage} />
      
      <Route path="/get-whitelisted" component={GetWhiteListed} />
    </Router>

  );
}

export default App;
